<!-- =========================================================================================
  File Name: DesignView.vue
  Description: Design View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/design/pixinvent
========================================================================================== -->

<template>
  <div id="page-design-view">
    <vs-alert
      color="danger"
      title="Design Not Found"
      :active.sync="design_not_found"
    >
      <span
        >Design record with id: {{ $route.params.designId }} not found.
      </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: 'page-design-list' }"
          class="text-inherit underline"
          >All Designs</router-link
        >
      </span>
    </vs-alert>
    <div id="design-data" v-if="design_data">
      <div class="relative">
        <div class="cover-container rounded-t-lg">
          <img :src="design_data.design_cover_img" alt="user-profile-cover" class="responsive block">
        </div>
      </div>
      <vx-card title="Design Details" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="design_data.design_logo" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td>Design Name</td>
                <td class="font-semibold">{{ design_data.design_name }}</td>
              </tr>
              <tr></tr>
              <tr>
                <td>Address</td>
                <td class="font-semibold">{{ designAddress }}</td>
              </tr>
              <tr>
                <td>Company</td>
                <td class="font-semibold">{{ design_data.company }}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>
                  <vs-chip
                    class="ag-grid-cell-chip"
                    :color="chipColor(design_data.status)"
                  >
                    <span>{{ design_data.status }}</span>
                  </vs-chip>
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td>Property type</td>
                <td class="font-semibold">{{ design_data.property_type }}</td>
              </tr>
              <tr>
                <td>Units qty</td>
                <td class="font-semibold">{{ design_data.units_qty }}</td>
              </tr>
              <tr>
                <td>Total area</td>
                <td class="font-semibold">
                  {{ design_data.total_area }} m<sup>2</sup>
                </td>
              </tr>
              <tr>
                <td>Sales price range</td>
                <td class="font-semibold">
                  {{ design_data.sales_price_range }} € per m<sup>2</sup>
                </td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{
                name: 'app-design-edit',
                params: { designId: $route.params.designId }
              }"
              >Edit</vs-button
            >
            <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
              >Delete</vs-button
            >
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Contacts" class="mb-base">
            <table>
              <tr>
                <td>Mobile</td>
                <td class="font-semibold">{{ design_data.mobile }}</td>
              </tr>
              <tr>
                <td>Website</td>
                <td class="font-semibold">{{ design_data.website }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td class="font-semibold">{{ design_data.email }}</td>
              </tr>
              <tr>
                <td>Contact</td>
                <td class="font-semibold">
                  {{ design_data.contact_options.join(", ") }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Social Links" class="mb-base">
            <table>
              <tr v-if="design_data.social_links.twitter">
                <td>Twitter</td>
                <td class="font-semibold">
                  {{ design_data.social_links.twitter }}
                </td>
              </tr>
              <tr>
                <td>Facebook</td>
                <td class="font-semibold">
                  {{ design_data.social_links.facebook }}
                </td>
              </tr>
              <tr>
                <td>Instagram</td>
                <td class="font-semibold">
                  {{ design_data.social_links.instagram }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>

      <!-- Wishlists -->
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Wishlists</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <table class="w-full wishlists-table">
            <tr>
              <!--
                You can also use `Object.keys(Object.values(data_local.wishlists)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               -->
              <th
                class="font-semibold text-base text-left px-3 py-2"
                v-for="heading in [
                  'Title',
                  'Category',
                  'Products qty',
                  'Attached'
                ]"
                :key="heading"
              >
                {{ heading }}
              </th>
            </tr>

            <tr v-for="(val, name) in design_data.wishlists" :key="name">
              <td class="px-3 py-2">{{ name }}</td>
              <td
                v-for="(wishlist, name) in val"
                class="px-3 py-2"
                :key="name + wishlist"
              >
                <vs-checkbox v-model="val[name]" class="pointer-events-none" />
              </td>
            </tr>
          </table>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleDesignManagement from "@/store/design-management/moduleDesignManagement.js";

export default {
  data() {
    return {
      design_data: null,
      design_not_found: false
    };
  },
  computed: {
    designAddress() {
      let str = "";
      for (const [key, value] of Object.entries(this.design_data.location)) {
        str += `${value} `;
      }
      return str;
    },
    chipColor() {
      return value => {
        if (value === "active") return "success";
        else if (value === "inactive") return "danger";
        else if (value === "archived") return "warning";
        else return "primary";
      };
    }
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.design_data.designname}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.$router.push({ name: "app-design-list" });
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting design */
      this.$store
        .dispatch("designManagement/removeRecord", this.design_data.id)
        .then(() => {
          this.$router.push({ name: "app-design-list" });
          this.showDeleteSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Design Deleted",
        text: "The selected design was successfully deleted"
      });
    }
  },
  created() {
    // Register Module DesignManagement Module
    if (!moduleDesignManagement.isRegistered) {
      this.$store.registerModule("designManagement", moduleDesignManagement);
      moduleDesignManagement.isRegistered = true;
    }

    const designId = this.$route.params.designId;
    this.$store
      .dispatch("designManagement/fetchDesign", designId)
      .then(res => {
        this.design_data = res.data;
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.design_not_found = true;
          return;
        }
        console.error(err);
      });
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-design-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
